import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Custom hook to update document title based on translation key
 * Updates automatically when language changes or translation key changes
 *
 * @param translationKey - The i18n translation key for the page title
 * @param params - Optional parameters for translation interpolation
 */
export function useDocumentTitle(
  translationKey: string,
  params?: Record<string, string | number>
): void {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    // Get the translated title
    const translatedTitle = t(translationKey, params)

    // Update document title with app name suffix
    document.title = `${translatedTitle} | Ijro tizimi`

    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = 'Ijro tizimi'
    }
  }, [t, translationKey, params, i18n.language]) // Re-run when language changes
}
